import facebookEngagementsBlock from './facebook-engagements-block';

export default {

    ...facebookEngagementsBlock,

}